const bottomVisible = () =>
  document.documentElement.clientHeight + window.scrollY >=
  (document.documentElement.scrollHeight ||
    document.documentElement.clientHeight);
// bottomVisible(); // true

const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
  const { top, left, bottom, right } = el.getBoundingClientRect();
  const { innerHeight, innerWidth } = window;
  return partiallyVisible
    ? ((top > 0 && top < innerHeight) ||
        (bottom > 0 && bottom < innerHeight)) &&
        ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
    : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
};
// e.g. 100x100 viewport and a 10x10px element at position {top: -1, left: 0, bottom: 9, right: 10}
// elementIsVisibleInViewport(el); // false - (not fully visible)
// elementIsVisibleInViewport(el, true); // true - (partially visible)

const getScrollPosition = (el = window) => ({
  x: el.pageXOffset !== undefined ? el.pageXOffset : el.scrollLeft,
  y: el.pageYOffset !== undefined ? el.pageYOffset : el.scrollTop
});
// {x: 0, y: 200}

const getStyle = (el, ruleName) => getComputedStyle(el)[ruleName];
// getStyle(document.querySelector('p'), 'font-size'); // '16px'

const setStyle = (el, ruleName, val) => (el.style[ruleName] = val);
// setStyle(document.querySelector('p'), 'font-size', '20px'); // The first <p> element on the page will have a font-size of 20px

const eventType = document.ontouchstart !== null ? 'click' : 'touchstart';

const scrollToTop = () => {
  const c = document.documentElement.scrollTop || document.body.scrollTop;
  if (c > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, c - c / 8);
  }
};
// scrollToTop();

/**
 * Высчитывает размеры скрытого элемента
 * @param {HTMLElement} element - элемент, размеры которого мы хотим получить
 * @returns {Object} - объект с свойствами width и height
 */
const calcHiddenElementSize = element => {
  const size = {};
  const pos = element.style.position;
  const visibility = element.style.visibility;
  const display = element.style.display;
  const height = element.style.height;
  const width = element.style.width;

  element.style.position = 'absolute';
  element.style.visibility = 'hidden';
  element.style.display = 'block';
  element.style.height = 'auto';
  element.style.width = 'auto';

  size.height = element.clientHeight;
  size.width = element.clientWidth;

  element.style.position = pos;
  element.style.visibility = visibility;
  element.style.display = display;
  element.style.height = height;
  element.style.width = width;

  return size;
};

/**
 * forEach для node list
 * @param {NodeList} list - Коллекция HTML элементов
 * @param {function} callback - Функция, которая должна быть вызвана для каэждого элемента в коллекции
 */
const forEach = (list, callback) => {
  Array.prototype.forEach.call(list, callback);
};

/**
 * Получить индекс элемента в наборе
 * @param {HTMLElement} element - элемент
 * @param {NodeList} set - Коллекция HTML элементов
 * @returns {(number | null)} - либо индекс, либо null, если элемента нет в этом наборе
 */
const indexOf = (element, set) => {
  let index = null;

  forEach(set, (item, ind) => {
    if (item === element) {
      index = ind;
      return;
    }
  });

  return index;
};

export {
  bottomVisible,
  elementIsVisibleInViewport,
  getScrollPosition,
  getStyle,
  setStyle,
  eventType,
  scrollToTop,
  calcHiddenElementSize,
  forEach,
  indexOf
};
